import { AppStrings } from './base-strings';

export const ja: AppStrings = {
  APP: {
    locale: 'ja-JP',
    lang: '日本語',
    confirmed: '确诊',
    forest: '森林',
    colon: ': ',
    introTitle: [
      '安心していても心配していても、',
      'あなたの周りの状況を把握できるのが一番です。',
    ].join('\n'),
    introBody: [
      '确诊森林™を使用して連絡先を記録します。',
      'あなたはあなたとあなたの可能性のある病気の間の距離（何層か）と自動計算された統計を見ることができました。',
      'したがって、対応する流行防止策を実行できます。',
    ].join('\n'),
    hint: [
      '确诊森林™の目標は、政府と一般市民がアウトブレイクの原因をより迅速に追跡できるようにすることです。 電話番号を使用してシステムにログインし、自分と密接な関係にある身元を（社会的距離を維持せずに）追加することにより、3度以内の接触の可能性のある症状を数えるのに役立ちます。',
      '全員が連絡先を記録すると、考えられる病気との距離（層の数）と自動計算された統計が表示され、対応する流行防止策を実行できます。 落ち着いていても心配していても、周りの状況を把握できるのが一番です。',
      '外出を減らし、集まりを避け、マスクを着用し、頻繁に手を洗って、みんなの健康を祈ります。',
      '＊すべての個人用リソースは、個々の統計、追跡、および健康管理を思い出させるためのものです。',
    ].join('\n'),
    contactUs: 'お問い合わせ',
  },
  LOGIN_SECTION: {
    hint: [
      'この電話番号は、連絡先の追加と症状の設定にのみ使用されます。',
      '＊注意：噂の疑いを回避するために、許可なく他人の携帯電話番号を使用しないでください。',
    ].join('\n'),
    title: '電話番号を入力してください',
    label: '電話番号',
    placeholder: '電話番号を入力してください',
    emptyWarning: '固有の電話番号を提供する必要があります',
    invalidWarning: '有効な電話番号を入力する必要があります',
    dialogAlertTitle: '情報を取得しています...',
    dialogAlertDescription: '少々お待ちください。 お待ちいただいてありがとうございます。',
  },
  SYMPTOM_SECTION: {
    hint: [
      '現在の症状を入力してください。',
      '心配しないでください、他の人はあなたの症状を見ることができません。',
      'それらは要約統計にのみ表示され、誰もが他人や自分自身を助けるために暴露履歴のリスクを理解するのに役立ちます。',
    ].join('\n'),
    title: '症状を選択してください',
    warning: '症状を選択する必要があります',
  },
  SYMPTOM: {
    confirmed: '新冠肺炎を确诊',
    cough: '咳',
    difficultyBreathing: '呼吸困難',
    fever: '熱',
    musclePain: '筋肉痛',
    newLossOfTasteOrSmell: '味や匂いの新たな喪失',
    quarantine: '検疫',
    soreThroat: '喉の痛み',
  },
  CONTACT_SECTION: {
    hint: '家族や友人、または感染症のリスクがあると感じる人は誰でも入ることができます。',
    title: '新しい連絡先を追加',
    label: '連絡先の電話番号',
    today: '今日',
    contactOfNDaysBefore: (n: number) => `${n}日前の連絡先`,
    placeholder: '連絡先の電話番号を入力してください',
    emptyWarning: '連絡先の電話番号を入力する必要があります',
    invalidWarning: '有効な電話番号を入力する必要があります',
  },
  STATISTIC_SECTION: {
    title: '今日の統計',
    nLevelContacts: ['1度以内の連絡先', '2度以内の連絡先', '3度以内の連絡先'],
    peopleUnit: '人',
  },
  BUTTON: {
    submit: '送り出す',
    login: 'ログインしてレポートを表示',
    loading: '読み込み中...',
    saving: '保存中...',
    edit: '編集する',
    cancel: 'キャンセル',
    delete: '削除する',
    refreshContact: '連絡先を更新',
  },
  ALERT: {
    loginFail:
      'ログインできませんでした：ネットワーク接続を確認するか、しばらくしてからもう一度お試しください',
    undefinedPhoneNumber: '未定義の電話番号',
  },
  DIALOG: {
    contact: '連絡先',
    lastContactDate: '最終連絡日',
    contactRefresh: '今日この連絡先に連絡した場合は、日付を更新できます。',
    contactDelete: '誤って追加した人を削除する可能性があります。',
  },
};
